import SystemFieldProto from '../../proto/system-field-proto';
import ProjectStatusSelector from 'core/gd-ui/select-status/project/project.jsx';
import TaskStatusSelector from 'core/gd-ui/select-status/task/task.jsx';
import SystemFieldStatusViewInImport from "./components/view-in-import";
import {EntityType} from "../../../gd/const/item"

export default class StatusField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.STATUS;
    }

    get sortHintMessage() {
        return 'Sort by status';
    }

    getCsvValue(item) {
        let res;

        // check item is task or project (systemType for both of them are of numeric value)
        if (item.taskTypeId) {
            res = gd.session.statuses.get(item.statusId).name;
        } else {
            switch (item.systemType){
                case gd.const.project.type.WORKFOLDER:
                case gd.const.project.type.BACKLOG:
                case gd.const.project.type.TAG:         res = gd.const.project.workfolderStatusList[item.systemStatus]; break;
                case gd.const.project.type.SPRINT:      res = gd.const.project.sprintStatusList[item.systemStatus]; break;
                default:                                res = gd.session.statuses.get(item.statusId)?.name; break;
            }
        }
        return res;
    }

    normalizeCSVValue(value) {

        value = value.trim();

        // find status by name
        const allStatuses = gd.session.statuses.filterByCompany(gd.companyId).models;

        const status = _.find(allStatuses,(status=>{
            return (!status.isDeleted && status.name.toLowerCase()===value.toLowerCase())
        }));

        if (status) {
            return status.id
        } else {
            return undefined;
        }
    }

    listItemSortFunctions(sort) {
        const functionsArray = [
            (i=>{
                if (!['task', 'project', EntityType.TASK, EntityType.PROJECT].includes(i.type)) return 0;

                let result;
                switch (i.item.systemType) {
                    case gd.const.project.type.WORKFOLDER:
                    case gd.const.project.type.BACKLOG:
                    case gd.const.project.type.SPRINT:
                    case gd.const.project.type.TAG:
                        result = i.item.systemStatus;
                        break;

                    default:
                        const status = gd.session.statuses.get(i.item.statusId)
                        result = status ? status.systemStatus : i.item.systemStatus
                        break;
                }

                return result;
            }),
            (i=>{
                let result = 0;
                if (i.item.taskTypeId) {
                    let taskType = gd.session.taskTypes.get(i.item.taskTypeId);
                    if (taskType) {
                        let taskTypeStatus = taskType.statuses.getByStatusId(i.item.statusId);
                        if (taskTypeStatus) result = taskTypeStatus.sortPosition;
                    }
                }
                return result;
            }),
            (i=>{
                if (!['task', 'project', EntityType.TASK, EntityType.PROJECT].includes(i.type)) return 0;

                let result;
                switch (i.item.systemType){
                    case gd.const.project.type.WORKFOLDER:
                    case gd.const.project.type.BACKLOG:
                    case gd.const.project.type.TAG:
                        result = gd.const.project.workfolderStatusList[i.item.systemStatus];
                        break;

                    case gd.const.project.type.SPRINT:
                        result = gd.const.project.sprintStatusList[i.item.systemStatus];
                        break;

                    default:
                        const status = gd.session.statuses.get(i.item.statusId)
                        result = status ? status.name.toLowerCase() : gd.const.project.workfolderStatusList[i.item.systemStatus];
                        break;
                }

                return result;
            }),
        ];

        const directionsArray = [sort, sort, sort];

        return {
            functions: functionsArray,
            directions: directionsArray
        }
    }

    getComponentViewInImport(value) {
        return SystemFieldStatusViewInImport;
    }

    getRenderComponent() {
        switch (this.entityType) {
            case gd.const.entityType.PROJECT: return ProjectStatusSelector;
            case gd.const.entityType.TASK: return TaskStatusSelector;
            default: throw new Error(this.constructor.name + ': getRenderComponent is not available');
        }
    }
}
